var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',[_vm._v(" "+_vm._s(_vm.$t("Rate this Gallery"))+" ")]),_c('b-form-rating',{attrs:{"size":"lg","variant":"warning"},model:{value:(_vm.rating),callback:function ($$v) {_vm.rating=$$v},expression:"rating"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }